import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../blogs/admin_blog.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";

const addAIBlogEndpoint = ApiEndpoints.AIBlogs.AIBlogCreate;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const categoryListEndpoint = ApiEndpoints.category.categoryList;
const tagListEndpoint = ApiEndpoints.tags.tagList;

export default function AddAIBlogs() {
  const navigate = useNavigate();
  const mandatoryFields = ["name", "slug", "category_id", "author_id", "tag1", "tag2", "tag3", "image", "alt_image", "description", "heading1", "description1", "image1", "alt_image1", "heading2", "description2", "conclusion", "conclusion_description", "image2",];

  const [preview, setPreview] = useState({ image: null, image1: null, image2: null, image3: null, image4: null, image5: null, image6: null, image7: null, });

  const [postData, setPostData] = useState({ name: "", slug: "", category_id: "", author_id: "", tag1: "", tag2: "", tag3: "", image: null, alt_image: "", description: "", heading1: "", description1: "", image1: null, alt_image1: "", heading2: "", description2: "", image2: null, alt_image2: "", heading3: "", description3: "", image3: null, alt_image3: "", heading4: "", description4: "", image4: null, alt_image4: "", heading5: "", description5: "", image5: null, alt_image5: "", heading6: "", description6: "", image6: null, alt_image6: "", heading7: "", description7: "", image7: null, alt_image7: "", conclusion: "", conclusion_description: "", faqs: [{ question: "", answer: "" }, { question: "", answer: "" },] });

  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [categoriesData, authorsData, tagsData] = await Promise.all([
          ApiRequest("GET", categoryListEndpoint),
          ApiRequest("GET", authorListEndpoint),
          ApiRequest("GET", tagListEndpoint),
        ]);
        setCategories(categoriesData?.blog_categories || []);
        setAuthors(authorsData?.authors || []);
        setTags(tagsData?.tags || []);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPostData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));

    if (type === "file" && files[0]) {
      setPreview((prevPreview) => ({
        ...prevPreview,
        [name]: URL.createObjectURL(files[0]),
      }));
    }
  };

  const handleEditorChange = (name, data) => {
    setPostData((prevData) => ({
      ...prevData,
      [name]: data,
    }));
  };

  // =========FAQS Functionality==========

  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedFaqs = [...prev.faqs];
      updatedFaqs[index][field] = value;
      return { ...prev, faqs: updatedFaqs };
    });
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    setPostData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  // 🔹 remove FAQ
  const removeFaq = (index) => {
    setPostData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  // =======FAQs Functionality End==========

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emptyFields = mandatoryFields.filter(
      (field) => !postData[field] || postData[field] === ""
    );

    if (emptyFields.length > 0) {
      toast.error("All fields are mandatory with {*} sign.");
      return;
    }

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      if (key === "faqs") {
        formData.append(key, JSON.stringify(postData[key]));
      } else {
        formData.append(key, postData[key]);
      }
    });

    try {
      const response = await ApiRequest("POST", addAIBlogEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.error === true) {
        toast.error(response.message)
      } else {
        toast.success(response.message)
        navigate("/admin/ai-blog");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add AI Blog</h5>
      </div>
      <div className="add-blog-content">
        <form onSubmit={handleSubmit}>
          <div className="row">

            <div className="col-md-12">
              <label>Title:*</label>
              <input name="name" type="text" value={postData.name} onChange={handleChange} className="form-control" />
            </div>

            <div className="col-md-12">
              <label>Slug:*</label>
              <input name="slug" type="text" value={postData.slug} onChange={handleChange} className="form-control" />
            </div>

            {/* Category Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="blogCategorySelect">Blog Category:*</label>
                <select name="category_id" className="form-control" id="blogCategorySelect" value={postData.category_id} onChange={handleChange}>
                  <option disabled value="">
                    Select Category
                  </option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Author Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="Author">Author:*</label>
                <select name="author_id" className="form-control" id="Author" value={postData.author_id} onChange={handleChange} >
                  <option disabled value=""> Select Author</option>
                  {authors.map((auth) => (
                    <option key={auth._id} value={auth._id}>
                      {auth.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Tags */}
            {[1, 2, 3].map((i) => (
              <div className="col-md-4" key={`tag${i}`}>
                <label>{`Tag ${i}:*`}</label>
                <select name={`tag${i}`} value={postData[`tag${i}`]} onChange={handleChange} className="form-control">
                  <option disabled value=""> Select Tag</option>
                  {tags.map((tag) => (
                    <option key={tag._id} value={tag._id}> {tag.name}</option>
                  ))}
                </select>
              </div>
            ))}

            <div className="col-lg-12">
              <div className="form-group">
                <label>Thumbnail Image (558x375 px):*</label>
                <input type="file" className="form-control" name="image" onChange={handleChange} />
                {preview.image && (
                  <div style={{ width: "60px", height: "60px", margin: "10px 0 0", overflow: "hidden" }}>
                    <img src={preview.image} alt="Preview" className="img-responsive" />
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label>Alt Thumbnail Image:*</label>
                <input type="text" className="form-control" name="alt_image" onChange={handleChange} />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="des1">Description:*</label>
                <CKEditor onChange={(event, editor) => handleEditorChange("description", editor.getData())} id="des1" editor={ClassicEditor} data={postData.description} config={{ toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "undo", "redo",], }} />
              </div>
            </div>

            {[1, 2, 3, 4, 5, 6, 7].map((section) => (
              <div key={section}>
                <div className="col-md-12">
                  <label>{(section === 1 || section === 2) ? `Heading${section}:*` : `Heading${section}:`}</label>
                  <input name={`heading${section}`} type="text" value={postData[`heading${section}`]} onChange={handleChange} className="form-control" />
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label>{(section === 1 || section === 2) ? `Description${section}:*` : `Description${section}:`}</label>
                    <CKEditor onChange={(event, editor) => handleEditorChange(`description${section}`, editor.getData())} editor={ClassicEditor} data={postData[`description${section}`]} config={{ toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "undo", "redo",], }} />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label>{(section === 1 || section === 2) ? `Image${section} (771X481 px):*` : `Image${section} (771 × 481 px):`}</label>
                    <input name={`image${section}`} type="file" className="form-control" onChange={handleChange} />

                    {preview[`image${section}`] && (
                      <div style={{ width: "60px", height: "60px", margin: "10px 0 0", overflow: "hidden" }}>
                        <img src={preview[`image${section}`]} alt="Preview" className="img-responsive" />
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label>{(section === 1 || section === 2) ? `Alt Image${section}:*` : `Alt Image${section}:`}</label>
                    <input name={`alt_image${section}`} type="text" className="form-control" onChange={handleChange} />
                  </div>
                </div>
              </div>
            ))}

            <div className="col-md-12">
              <label>Conclusion:*</label>
              <input name="conclusion" type="text" value={postData.conclusion} onChange={handleChange} className="form-control" />
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label>Conclusion Description*</label>
                <CKEditor onChange={(event, editor) => handleEditorChange("conclusion_description", editor.getData())} editor={ClassicEditor} data={postData.conclusion_description} config={{ toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "undo", "redo",], }} />
              </div>
            </div>

            <div className="add-content-wrap mt-5">
              <h5>Faq Section</h5>
              <div className="row">
                {postData.faqs.map((faq, index) => (
                  <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                    <div className="add-page-inputs input-add-image">
                      <div className="label-wrap-add">
                        <label>Question<small>*</small></label>
                      </div>
                      <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                    </div>

                    <div className="mb-3">
                      <div className="label-wrap-add">
                        <label>Answer<small>*</small></label>
                      </div>
                      <input required className="form-control" placeholder={`Answer ${index + 1}`}
                        value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} />
                    </div>
                    {index >= 2 && (
                      <button type="button" style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }} onClick={() => removeFaq(index)}>
                        REMOVE
                      </button>
                    )}
                  </div>
                ))}

                <div className="col-lg-12 text-center">
                  <button type="button" className="add-faqs" onClick={addFaq} style={{ background: "green", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", padding: "5px 15px", marginTop: "15px" }}>
                    Add New Faq
                  </button>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                Add AI Blog
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
